// Sahib üçün mobil tətbiq (KT-94): PWA — saytdan quraşdırılır. Service worker yalnız tətbiq qabığını və statik faylları
// keşləyir; məlumat (satış, qalıq) keşlənmir. Mobil görünüş: /m ünvanı və ya quraşdırılmış tətbiq (standalone).

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferred: BeforeInstallPromptEvent | null = null;
const listeners = new Set<() => void>();

/** Brauzer quraşdırmanı təklif edəndə (Android/Chrome) hadisə saxlanır — «Tətbiqi yüklə» düyməsi onu açır. */
export function initPwa(): void {
  if (typeof window === 'undefined') return;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferred = e as BeforeInstallPromptEvent;
    listeners.forEach((f) => f());
  });
  window.addEventListener('appinstalled', () => {
    deferred = null;
    listeners.forEach((f) => f());
  });
  if ('serviceWorker' in navigator && import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => undefined);
    });
  }
}

export function onInstallChange(f: () => void): () => void {
  listeners.add(f);
  return () => listeners.delete(f);
}

export function canPromptInstall(): boolean {
  return deferred !== null;
}

/** Quraşdırma pəncərəsi (Android/Chrome). true — istifadəçi qəbul etdi. */
export async function promptInstall(): Promise<boolean> {
  if (!deferred) return false;
  const e = deferred;
  deferred = null;
  await e.prompt();
  const choice = await e.userChoice;
  listeners.forEach((f) => f());
  return choice.outcome === 'accepted';
}

/** Tətbiq kimi açılıb (ana ekrandan). */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = navigator as Navigator & { standalone?: boolean };
  return window.matchMedia?.('(display-mode: standalone)').matches === true || nav.standalone === true;
}

/** iPhone/iPad Safari: quraşdırma pəncərəsi yoxdur — «Paylaş → Ana ekrana əlavə et» təlimatı göstərilir. */
export function isIos(
  ua: string = typeof navigator === 'undefined' ? '' : navigator.userAgent,
  touchPoints: number = typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints,
): boolean {
  // iPadOS 13+ özünü «Macintosh» kimi təqdim edir — toxunma ekranı ilə tanınır
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && touchPoints > 1);
}

/** Mobil görünüş: /m ünvanı və ya quraşdırılmış tətbiq. */
export function isMobileApp(path: string = typeof window === 'undefined' ? '/' : window.location.pathname): boolean {
  return path === '/m' || path.startsWith('/m/') || isStandalone();
}

/** Bakı tarixi (YYYY-MM-DD), gün sürüşməsi ilə: 0 — bu gün, -1 — dünən. */
export function bakuDay(offsetDays = 0, now: Date = new Date()): string {
  const d = new Date(now.getTime() + offsetDays * 86_400_000);
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Baku', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
}

/** Bu ayın birinci günü (Bakı). */
export function bakuMonthStart(now: Date = new Date()): string {
  return `${bakuDay(0, now).slice(0, 8)}01`;
}
